import axios from 'axios';

import config from '@/config';

const client = axios.create({
  baseURL: config.neutron_url,
  headers: {
    'X-UI-AppName': 'Juno'
  }
});

export default client;
